/**
 * Installatie op het beginscherm (B3). Android levert `beforeinstallprompt`; iOS Safari
 * heeft dat niet en krijgt daarom de eenmalige uitleg-sheet.
 */

interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<void>;
}

let pending: BeforeInstallPromptEvent | null = null;

export function captureInstallPrompt(event: Event): void {
  event.preventDefault();
  pending = event as BeforeInstallPromptEvent;
}

export async function showInstallPrompt(): Promise<void> {
  await pending?.prompt();
  pending = null;
}

/** iOS Safari buiten de geïnstalleerde app: daar is alleen uitleg mogelijk. */
export function isIosBrowser(): boolean {
  if (typeof navigator === 'undefined' || typeof window === 'undefined') return false;
  const ios = /iPad|iPhone|iPod/.test(navigator.userAgent);
  const standalone =
    window.matchMedia('(display-mode: standalone)').matches ||
    (navigator as unknown as { standalone?: boolean }).standalone === true;
  return ios && !standalone;
}
